/* eslint-disable no-undef */
import { encode, toastWrapper } from '@utils/helpers';
import { store } from 'redux/store';
import { genericService } from 'shared/GenericService';

export * from '../features/cx-actions/reducer/CxActionActions';
export * from "../features/cx-assessements/reducer/CxAssessementsActions";
export * from "../features/folders/reducer/FoldersActions";
export * from "../features/forms/cx-programs/reducer/CxProgramActions";
export * from "../features/forms/personas/reducer/PersonaActions";
export * from "../features/insights/reducer/InsightActions";
export * from '../features/journey-map/reducer/CJMActions';
export * from "../features/library/reducer/LibraryActions";
export * from "../features/opportunity/reducer/OpportunityActions";
export * from "../features/settings/reducer/SettingsActions";
export * from "../features/settings/reducer/TeamActions";
export * from "../features/settings/reducer/UserActions";
export * from "../features/solutions/reducer/SolutionsActions";

const InitActionCreator = ({ baseUrl, method }) => {
	return ({ type, endPoint, data, responseType, params, meta,headers }) => ({
		type,
		request: {
			url: baseUrl + endPoint,
			method,
			data,
			responseType,
		},
		headers,
		meta,
		params,
	});
};
export const updateLanguage = (language) => {
	return {
		type: "UPDATE_LANGUAGE",
		payload: language,
	};
};

export const submitReportRequest = (Subject, Message) => {
	return {
		type: "SUBMIT_REPORT_REQUEST",
		request: {
			url: "api/bo/submitReportRequest",
			method: "post",
			data: {
				Subject,
				Message,
			},
		},
	};
};




export const getNotifs = () => {
	return {
		type: 'GET_NOTIFICATIONS',
		request: {
			url: 'api/notif/getMyLast30',
			method: 'GET',

		},
		meta: { joinRequest: 'GET_NOTIFICATIONS' },

	}
}
export const dismissNotifs = ({ notificationIds }) => {
	return {
		type: 'DISMISS_NOTIFICATIONS',
		request: {
			url: 'api/notif/dismiss',
			method: 'POST',
			data: {
				notificationIds: notificationIds
			}

		},

	}
}
export const updateStatusNotifs = ({ seen, notificationId }) => {
	return {
		type: 'UPDATE_STATUS_NOTIFICATION',
		request: {
			url: 'api/notif/updateStatus',
			method: 'POST',
			data: {
				seen: seen,
				notificationId: notificationId
			}

		}
	}
}

export const createNotif = ({ mentionedUsersId, notificationType, referencedObjectId, referenceObjectUrl }) => {
	return {
		type: 'CREATE_NOTIFICATION',
		request: {
			url: 'api/notif/create',
			method: 'POST',
			data: {
				mentionedUsersId: mentionedUsersId,
				notificationType: notificationType,
				referencedObjectId: referencedObjectId,
				referenceObjectUrl: referenceObjectUrl
			}

		}
	}
}

const createPostAttachment = InitActionCreator({ baseUrl: "api/attachment/", method: "POST" }); // api actions type post

const getFile = ({ name, itemId, objId, objName }) => createPostAttachment({
	type: "GET_FILE", endPoint: "getFile",
	data: {
		name: encode(name),
		itemId: itemId,
		objId: objId,
		objName: objName
	},
	responseType: "blob",

});
export const getFileService = ({ name, itemId, objId, objName }) => {
	const promise = async () => {
		const { data, error } = await store.dispatch(getFile({ name, itemId, objId, objName }));
		var fileDownload = require("js-file-download");
		fileDownload(data, name);
		if (error) throw error;
	};
	toastWrapper(promise, "EXPORT");
};
const createPosAttribute = InitActionCreator({ baseUrl: "api/cxattribute/", method: "POST" });
// api actions type post
export const updateAttributeAPI = ({ modfifiedCxAttribute, modifiedAttribNames, ...props }) => genericService({
	...props,
	action: createPosAttribute({
		type: "UPDATE_CX_ATTRIBUTE",
		endPoint: "update",
		data: {
			modifiedCxAttribute: modfifiedCxAttribute,
			modifiedAttribNames: modifiedAttribNames,
		},
	}),
});

export const updateAttributeAPIMulti = ({ modifiedCxAttributes, modifiedAttribNames, ...props }) => genericService({
	...props,
	action: createPosAttribute({
		type: "UPDATE_CX_ATTRIBUTES",
		endPoint: "updateMulti",
		data: {
			modifiedCxAttributes,
			modifiedAttribNames,
		},
	}),
});




export const linkRecordAttributeAPI = ({ recEntityName, recIds, attributeId, objId, objName, ...props }) => genericService({
	...props,
	action: createPosAttribute({
		type: "LINK_CX_ATTRIBUTE",
		endPoint: "linkRecords",
		data: {
			recEntityName: recEntityName,
			recIds: recIds, // array of record ids to link
			cxAttributeId: attributeId,
			objId: objId,
			objName: objName

		},
	}),
});


export const unlinkRecordAttributeAPI = ({ recEntityName, recIds, attributeId, objId, objName, ...props }) => genericService({
	...props,
	action: createPosAttribute({
		type: "UNLINK_CX_ATTRIBUTE",
		endPoint: "unLinkRecords",
		data: {
			recEntityName: recEntityName,
			recIds: recIds, // array of record ids to link
			cxAttributeId: attributeId,
			objId: objId,
			objName: objName
		},
	}),
});

export const updateUserModification = ({ objId, objName, userName, ...props }) => genericService({
	...props,
	action: createPosAttribute({
		type: "UPDATE_USER_MODIFICATION",
		endPoint: "updateUserModification",
		data: {
			objId: objId,
			objName: objName
		},
		params: {
			userName
		}
	}),
});


export const upsertCXAttributeAttachItem = ({ data, ...props }) => {
	genericService({
		...props, action: createPosAttribute({
			type: "UPSERT_CX_ATTRIBUTE_ATTACH_ITEM",
			headers: {
				ContentType: "multipart/form-data"
			},
			endPoint: "upsertCxAttributeAttachItem",
			data: data
		}),
	});
};

export const deleteCxAttributeItem = ({ attributeItemId, attributeId, objId, objName, ...props }) => {
	genericService({
		...props, action: createPosAttribute({
			type: "DELETE_CX_ATTRIBUTE_ATTACH_ITEM",
			endPoint: "deleteCxAttributeItem",
			data: {
				attributeItemId, attributeId, objId, objName
			}
		}),
	});
};

export const purgeStore = () => {
	return {
		type: "PURGE",
	};
}